

import React, { useState, useEffect } from 'react';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import PageHeader from '../../components/common/PageHeader/PageHeader';
import SmallDetailBox from '../../components/common/DetailBox/SmallDetailBox';
import LargeDetailBox from '../../components/common/DetailBox/LargeDetailBox';
import LargeDetailTextBox from '../../components/common/DetailBox/LargeDetailTextBox';
import './CustomerDetail.css';
import DownloadLabel from '../../components/common/DownloadLabel/Download';
import ExportLabel from '../../components/common/ExportLabel/Export';
import LargeDetailBoxWithIcon from '../../components/common/DetailBox/DetailBoxWithIcon';
import SmallDetailBoxWithIcon from '../../components/common/DetailBox/SmallDetailBoxWithIcon';
import UserEditPopup from '../../components/Popup/UserEditPopup/UserEditPopup';
import { baseurl } from '../../api';
import UserLimitViewPopup from '../../components/Popup/UserEditPopup/UserLimitViewPopup';
import { isEmail, isNumberOnly, isRequired } from '../../validation';
import SelectBoxSmall from '../../components/common/SelectBox/SelectBoxSmall';
import InputBoxSmall from '../../components/common/InputBox/InputBoxSmall';
import InputBoxLarge from '../../components/common/InputBox/InputBoxLarge';
import InputAndSelectWithIconBoxSmall from '../../components/common/InputBox/InpuSelectIcon';
import TextBox from '../../components/common/TextBox/TextBox';
import authenticatedAxios from '../../authenticatedAxios';
import { useCheckboxClick } from '../../checkboxclick';
import SearchSelectBoxDrown from '../../components/common/SelectBox/searchSelect';
import ArchivePopup from '../../components/Popup/ArchivePopup/ArchivePopup';
import PhoneInputSelect from '../../components/common/SelectBox/PhoneInputSelect';
import Pagination from '../../components/common/Pagination/pagination';


const CustomerDetail = () => {

  const [customerData, setCustomerData] = useState(null);
  const [userData, setUserData] = useState([]);
  const [subscriptionData, setSubscriptionData] = useState([]);
  const [isAdvanced, setIsAdvanced] = useState(false);
  const [isEdit, setIsEdit] = useState(false);
  const [profilePicFile, setProfilePicFile] = useState(null);
  const [profilePicPreview, setProfilePicPreview] = useState(null);
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [isViewPopupOpen, setIsViewPopupOpen] = useState(false);
  const [selected, setSelected] = useState(null);
  const [isArchivePopupOpen, setIsArchivePopupOpen] = useState(false);
  const [items, setItems] = useState([]);
  const { isParentSelected, selectedItems, handleParentCheckboxChange, handleChildCheckboxChange, resetCheckboxState, } = useCheckboxClick(userData);
  const location = useLocation();
  const from = location.state?.from || 'customers';
  const [history, setHistory] = useState([]);
  const [subscriptions, setSubscriptions] = useState([]);
  const [userPagination, setUserPagination] = useState({});

  const navigate = useNavigate();
  const { id } = useParams();
  const currentLimit = 10;

  // Constants
  const statusMap = {
    'active': 'Active',
    'inactive': 'Inactive'
  };

  useEffect(() => {
    fetchCustomerDetail();
    fetchInitialData();
  }, [id]);

  const pageHeaderProps = {
    pageName: from === 'subscriptions' ? 'Subscriptions /' : 'Subscriptions / Customers /',
    nestedpageName: `${customerData?.name} `,
    linkTo: from === 'subscriptions' ? '/subscriptions' : '/customers',
  };

  useEffect(() => {
    console.log("User Data", customerData)
  }, [customerData])


  const fetchInitialData = async () => {
    try {
      const [countriesResponse, currenciesResponse] = await Promise.all([
        authenticatedAxios.get(`${baseurl}localization/country/`),
        authenticatedAxios.get(`${baseurl}currency/`)
      ]);

      setCountries(countriesResponse.data.data || []);
      setCurrencies(currenciesResponse.data.data || []);
    } catch (error) {
      console.error('Error fetching initial data:', error);
    }
  };

  // const fetchStates = async (countryId) => {
  //   try {
  //     const response = await authenticatedAxios.get(`${baseurl}localization/state/`, { params: { country: countryId } });
  //     setStates(response.data.data || []);
  //   } catch (error) {
  //     console.error('Error fetching states:', error);
  //   }
  // };

  const fetchStates = async (countryId) => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}localization/state/`, { params: { country: countryId } });
      setStates(response.data.data || []);
      return response.data.data || [];
    } catch (error) {
      console.error('Error fetching states:', error);
      return [];
    }
  };

  // When entering edit mode, make sure states are loaded for the current country
  useEffect(() => {
    if (isEdit && customerData?.country?.id) {
      fetchStates(customerData.country.id);
    }
  }, [isEdit, customerData?.country?.id]);


  const formatDate = (dateStr) => {
    if (!dateStr) return "N/A";
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };


  // const handleCountryChange = (e) => {
  //   const countryId = e.target.value;
  //   setCustomerData(prev => ({
  //     ...prev,
  //     country: countries.find(c => c.id === parseInt(countryId)),
  //     state: null // Reset state when country changes
  //   }));
  //   fetchStates(countryId);
  // };

  const handleCountryChange = async (e) => {
    const countryId = e.target.value;
    const selectedCountry = countries.find(c => c.id === parseInt(countryId));

    // Update customer data with new country but keep other fields intact
    setCustomerData(prev => ({
      ...prev,
      country: selectedCountry,
      // Don't reset state completely, just set the ID to null
      state: null
    }));

    // Fetch states for the new country
    await fetchStates(countryId);
  };

  const handleProfilePicChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setProfilePicFile(file);
      setProfilePicPreview(URL.createObjectURL(file));
    }
  };

  const handleEditProfilePic = () => {
    document.getElementById('profile-pic-input').click();
  };

  const handleUpdate = async () => {
    try {
      const formData = new FormData();

      if (profilePicFile) {
        formData.append('profile_pic', profilePicFile);
      }

      // Append all customer details
      formData.append('name', customerData.name);
      formData.append('email', customerData.email);
      formData.append('tax_id', customerData.tax_id);
      formData.append('work_phone', customerData.work_phone);
      formData.append('mobile_number', customerData.mobile_number);
      formData.append('country_code', customerData.country_code?.id);
      formData.append('website_url', customerData.website_url);
      formData.append('currency', customerData.currency?.id);
      formData.append('fax', customerData.fax);
      formData.append('note', customerData.note);
      formData.append('country', customerData.country?.id);
      formData.append('state', customerData.state?.id);
      formData.append('street_1', customerData.street_1);
      formData.append('street_2', customerData.street_2);
      formData.append('city', customerData.city);
      formData.append('pin_code', customerData.pin_code);

      const response = await authenticatedAxios.put(`${baseurl}organization/?id=${id}`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });

      // if (response.data.response_code === 1) {
      //   setCustomerData(response.data.data);
      //   setIsEdit(false);
      //   setProfilePicPreview(null);
      // }
      if (response.data.response_code === 1) {
        // After successful update, fetch the complete customer details again
        // This ensures we have the complete data structure with all nested objects
        await fetchCustomerDetail();
        setIsEdit(false);
        setProfilePicPreview(null);
      }
    } catch (error) {
      console.error('Error updating customer:', error);
    }
  };



  const handleToggle = (section) => {
    setIsAdvanced(section === 'advanced');
  };

  const iconSvg = (
    <svg className='url-icon' width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M4.76177 6.83313L6.06606 5.63813C6.4227 5.31074 6.67336 4.88425 6.78588 4.41339C6.8984 3.94253 6.86765 3.44879 6.69756 2.99553L6.14136 1.51029C5.93355 0.955803 5.52217 0.501401 4.99101 0.239659C4.45986 -0.0220827 3.84889 -0.0714727 3.28259 0.101552C1.19863 0.739126 -0.403197 2.67614 0.0898605 4.97627C0.414113 6.48944 1.03469 8.38881 2.21025 10.4096C3.38825 12.4353 4.73383 13.9315 5.88754 14.9832C7.62903 16.568 10.1186 16.1721 11.7204 14.6783C12.1496 14.2778 12.4099 13.7288 12.4485 13.1431C12.4871 12.5574 12.301 11.979 11.9281 11.5257L10.908 10.287C10.6003 9.91237 10.1876 9.63841 9.72293 9.50033C9.25826 9.36225 8.76291 9.36637 8.30061 9.51215L6.61498 10.0429C6.17942 9.59383 5.79792 9.09536 5.47828 8.55761C5.16983 8.01381 4.9292 7.43426 4.76177 6.83191" fill="#424242" />
    </svg>
  );
  const mobileIconSvg = (
    <svg className='url-icon' width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M8.5 0H1.5C0.675 0 0 0.675 0 1.5V14.5C0 15.325 0.675 16 1.5 16H8.5C9.325 16 10 15.325 10 14.5V1.5C10 0.675 9.325 0 8.5 0ZM3 0.75H7V1.25H3V0.75ZM5 15C4.73478 15 4.48043 14.8946 4.29289 14.7071C4.10536 14.5196 4 14.2652 4 14C4 13.7348 4.10536 13.4804 4.29289 13.2929C4.48043 13.1054 4.73478 13 5 13C5.26522 13 5.51957 13.1054 5.70711 13.2929C5.89464 13.4804 6 13.7348 6 14C6 14.2652 5.89464 14.5196 5.70711 14.7071C5.51957 14.8946 5.26522 15 5 15ZM9 12H1V2H9V12Z" fill="#424242" />
    </svg>
  );

  const ChangeUser = async (formValues) => {
    try {

      formValues.subscription = selected

      const response = await authenticatedAxios.post(`${baseurl}subscriptions/change-user-count/`, formValues, {
        headers: {
          'Content-Type': 'application/json',
        }
      });

      if (response.status >= 200 && response.status < 300) {
        console.log('User change successful');
        closePopups();
        fetchSubscriptions();
      } else {
        console.error('Failed to change user');
      }
    } catch (error) {
      console.error('Error changing user:', error);
    }
  };

  const closePopups = () => {
    setIsPopupOpen(false);
  };

  const fetchSubscriptions = async () => {
    try {
      const params = {

      };

      const response = await authenticatedAxios.get(`${baseurl}subscriptions/`, { params });

      if (response.data.response_code === 1) {
        setSubscriptions(response.data.data);
      } else {
      }
    } catch (error) {
    }
  };

  // const handleArchiveClick = async (item) => {
  //   try {
  //     const action = item.is_archived ? 'unarchive' : 'archive';
  //     await authenticatedAxios.post(`${baseurl}organization/${action}/`, {
  //       id: item,
  //     });
  //     handleClose();
  //   } catch (error) {
  //     console.error('Error toggling archive status:', error);
  //   }
  // };

  const handleArchiveClick = async () => {
    try {

      const response = await authenticatedAxios.get(`${baseurl}organization/archive/?id=${customerData?.id}`);

      if (response.status >= 200 && response.status < 300) {
        navigate("/customers")
      } else {
        console.error('Failed to archive .');
      }
    } catch (error) {
      console.error('Error archiving :', error);
    }
  };

  const paymentOptions = [
    { value: 'Payment', label: '--select--' },
    { value: 'UPI', label: 'UPI' },
    { value: 'Bank', label: 'Bank' }
  ];

  const fetchUsers = async (organizationId, page = null) => {
    try {
      const params = {};
      if (page) params.page = page;

      const response = await authenticatedAxios.get(`${baseurl}accounts/users/organization/${organizationId}/`, { params });
      if (response.data.response_code === 1) {
        setUserData(response.data.data);
        if (response.data.pagination) {
          setUserPagination(response.data.pagination);
        }
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    }
  };

  const handleUserPageChange = (page) => {
    fetchUsers(customerData?.id, page);
  };

  // const fetchCustomerDetail = async () => {
  //   try {
  //     const response = await authenticatedAxios.get(`${baseurl}organization/`, { params: { id } });
  //     if (response.data.response_code === 1) {
  //       setCustomerData(response.data.data);
  //       fetchUsers(response.data.data.id);
  //       fetchSubscriptionHistory(response.data.data.id);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching customer details:', error);
  //   }
  // };

  const fetchCustomerDetail = async () => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}organization/`, { params: { id } });
      if (response.data.response_code === 1) {
        setCustomerData(response.data.data);

        // If customer has a country, fetch its states immediately
        if (response.data.data.country?.id) {
          await fetchStates(response.data.data.country.id);
        }

        fetchUsers(response.data.data.id);
        fetchSubscriptionHistory(response.data.data.id);
      }
    } catch (error) {
      console.error('Error fetching customer details:', error);
    }
  };

  const fetchSubscriptionHistory = async (companyId) => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}subscriptions/history?company=${companyId}`);
      if (response.data.response_code === 1) {
        const history = response.data.data;
        // setSubscriptionHistory(history);
        setSubscriptionData(history); // Update subscription data for the table

        // Set renew count popup data
        // setRenewPopupTitle('RENEW COUNT');
        const activePlanStartDate = history.find(row => row.status.toLowerCase() === 'active')?.start_date || 'N/A';
        // setRenewPopupDate(activePlanStartDate);
      }
    } catch (error) {
      console.error('Error fetching subscription history:', error);
    }
  };

  const fetchHistory = async (subscriptionId) => {
    try {
      const response = await authenticatedAxios.get(`${baseurl}subscriptions/user-history/?subscription=${subscriptionId}`);
      if (response.data.response_code === 1) {
        const formattedHistory = response.data.data.map(item => ({
          ...item,
          date: item.date.split("T")[0]
        }));
        setHistory(formattedHistory);
      }
    } catch (error) {
      console.error('Error fetching user history:', error);
    }
  };

  // const handleChangeUser = async (formValues) => {
  //   try {
  //     formValues.subscription = selected;
  //     const response = await authenticatedAxios.post(`${baseurl}subscriptions/change-user-count/`, formValues, {
  //       headers: {
  //         'Content-Type': 'application/json',
  //       }
  //     });

  //     if (response.status >= 200 && response.status < 300) {
  //       closePopups();
  //       fetchSubscriptionHistory(id);
  //     }
  //   } catch (error) {
  //     console.error('Error changing user count:', error);
  //   }
  // };

  useEffect(() => {
    fetchCustomerDetail();
  }, [id]);


  const handleExportComplete = () => {
    resetCheckboxState();
  };

  const handleInputChange = (field, value) => {
    setCustomerData(prev => ({
      ...prev,
      [field]: value,
    }));

  };

  return (
    <div className='whole-container'>
      <div className="top-heading">
        <PageHeader {...pageHeaderProps} />
        <div className="export-container">
          <DownloadLabel />
          <ExportLabel
            exportUrl={`${baseurl}accounts/organizational/users/export/`}
            selectedIds={selectedItems}
            onExportComplete={handleExportComplete}
          />
        </div>
      </div>
      <div className='customer-detail-content'>
        <div className='left-customer-details-whole'>
          <div className='company-left-first left-customer'>
            <div className='company-img-name-container'>
              <div className='company-img-container'>
                {!isEdit ? (
                  <img
                    // src={customerData?.profile_pic ? `https://salesroutephase2.technaureus.com${customerData.profile_pic}` : "/assets/avatar.jpg"}
                    src={
                      customerData?.profile_pic
                        ? `${baseurl.replace(/\/$/, '')}/${customerData.profile_pic.replace(/^\//, '')}`
                        : "/assets/avatar.jpg"
                    }
                    alt="Profile"
                    className="comp-img user-image"
                  />
                ) : (
                  <>
                    <img
                      // src={profilePicPreview || (customerData?.profile_pic ? `https://salesroutephase2.technaureus.com${customerData.profile_pic}` : '/assets/avatar.jpg')}
                      src={
                        profilePicPreview ||
                        (customerData?.profile_pic
                          ? `${baseurl.replace(/\/$/, '')}/${customerData.profile_pic.replace(/^\//, '')}`
                          : '/assets/avatar.jpg')
                      }
                      alt="Profile"
                      className="comp-img user-image"
                    />
                    <img
                      src="/assets/company_edit.png"
                      alt="edit"
                      className="edit-company"
                      onClick={handleEditProfilePic}
                    />
                    <input
                      id="profile-pic-input"
                      type="file"
                      accept="image/*"
                      style={{ display: 'none' }}
                      onChange={handleProfilePicChange}
                    />
                  </>
                )}
              </div>
              <div>
                <span className='common-text fts-17 dk-gray'>{customerData?.name || "N/A"}</span>
                <span className='common-text fts-13 lt-gray txt-lc'>{customerData?.email || "N/A"}</span>
              </div>
            </div>
            <div className='company-edit-button'>
              <button className='fts-15 black' onClick={isEdit ? handleUpdate : () => setIsEdit(true)}>
                {isEdit ? 'Save' : 'Edit'}
              </button>
            </div>
          </div>

          <div className='main-left-second left-customer'>
            <div className='button-group'>
              <button
                onClick={() => handleToggle('overview')}
                className={`toggle-button common-text fts-15 ftw-4 ${!isAdvanced ? 'active' : ''}`}
              >
                Overview
              </button>
              <button
                onClick={() => handleToggle('advanced')}
                className={`toggle-button common-text fts-15 ftw-4 ${isAdvanced ? 'active' : ''}`}
              >
                Advanced
              </button>
            </div>

            <div className='company-left-second'>
              {!isAdvanced ? (
                <div className='company-details-first Overview'>
                  {!isEdit ? (
                    <>
                      <LargeDetailBox label="Company Name" value={customerData?.name || "N/A"} />
                      <SmallDetailBox className="txt-lc" label="Email" value={customerData?.email || "N/A"} />
                      <SmallDetailBox label="Tax ID" value={customerData?.tax_id || "N/A"} />
                      <SmallDetailBoxWithIcon
                        label="Work Phone"
                        icon={iconSvg}
                        value={customerData?.work_phone || "N/A"}
                      />
                      <SmallDetailBoxWithIcon
                        label="Mobile Number"
                        icon={mobileIconSvg}
                        value={`${customerData?.country_code?.country_code || ''} ${customerData?.mobile_number || ''}`}
                      />
                      <LargeDetailBoxWithIcon label="Website URL" value={customerData?.website_url || "N/A"} />
                      <SmallDetailBox label="Currency" value={customerData?.currency?.name || "N/A"} />
                      <SmallDetailBox label="Fax" value={customerData?.fax || "N/A"} />
                      <LargeDetailTextBox label="Notes" value={customerData?.note || "N/A"} />
                    </>
                  ) : (
                    <>
                      <InputBoxLarge
                        label="Company Name"
                        border='blue-border'
                        defaultValue={customerData?.name}
                        onChange={(e) => setCustomerData({ ...customerData, name: e.target.value })}
                        validators={[isRequired]}
                      />
                      <InputBoxSmall
                        label="Email"
                        className="w-50"
                        border='blue-border'
                        defaultValue={customerData?.email}
                        onChange={(e) => setCustomerData({ ...customerData, email: e.target.value })}
                        validators={[isRequired, isEmail]}
                      />
                      <InputBoxSmall
                        label="Tax ID"
                        className="w-50"
                        border='blue-border'
                        defaultValue={customerData?.tax_id}
                        onChange={(e) => setCustomerData({ ...customerData, tax_id: e.target.value })}
                      />
                      <InputBoxSmall
                        label="Work Phone"
                        className="w-50"
                        border='blue-border'
                        defaultValue={customerData?.work_phone}
                        onChange={(e) => setCustomerData({ ...customerData, work_phone: e.target.value })}
                        validators={[isNumberOnly]}
                      />
                      {/* <InputAndSelectWithIconBoxSmall
                        label="Mobile Number"
                        name="mobile_number"
                        opt="country_code"
                        border='blue-border'                 
                        options={countries.map(c => ({
                          value: c.id.toString(),
                          label: c.country_code
                        }))}
                        onChange={({ type, value }) => {
                          if (type === 'input') {
                            setCustomerData(prev => ({ ...prev, mobile_number: value }));
                          } else if (type === 'select') {
                            const selectedCountry = countries.find(c => c.id === parseInt(value));
                            if (selectedCountry) {
                              setCustomerData(prev => ({ ...prev, country_code: selectedCountry }));
                            }
                          }
                        }}
                        className="w-50"
                        defaultValue={customerData?.mobile_number}
                        defaultOption={customerData?.country_code?.id?.toString()}
                      /> */}

                      <PhoneInputSelect
                        label="Mobile Number"
                        className='w-50'
                        options={countries.map(c => ({
                          value: c.id.toString(),
                          label: `${c.country_code} `
                        }))}

                        border='blue-border'
                        onChange={(e) => handleInputChange("phone", e.target.value)}
                        onSelectChange={(e) => handleInputChange("country_code", e.target.value)}
                        defaultValue={customerData?.mobile_number}
                        defaultOption={customerData?.country_code?.id?.toString()}
                        validators={[isNumberOnly]}
                      />
                      <InputBoxLarge
                        label="Website URL"
                        border='blue-border'
                        defaultValue={customerData?.website_url}
                        onChange={(e) => setCustomerData({ ...customerData, website_url: e.target.value })}
                      />
                      <SearchSelectBoxDrown
                        label="Currency"
                        className="w-50"
                        border='blue-border'
                        options={currencies.map(curr => ({
                          value: curr.id.toString(),
                          label: curr.name
                        }))}
                        defaultValue={customerData?.currency?.id?.toString()}
                        onChange={(e) => setCustomerData({
                          ...customerData,
                          currency: currencies.find(curr => curr.id === parseInt(e.target.value))
                        })}
                      />
                      <InputBoxSmall
                        label="Fax"
                        className="w-50"
                        border='blue-border'
                        defaultValue={customerData?.fax}
                        onChange={(e) => setCustomerData({ ...customerData, fax: e.target.value })}
                      />
                      <TextBox
                        label="Notes"
                        border='blue-border'
                        defaultValue={customerData?.note}
                        onChange={(e) => setCustomerData({ ...customerData, note: e.target.value })}
                      />
                    </>
                  )}
                </div>
              ) : (
                <div className='company-details-first advanced'>
                  <LargeDetailBox label="Currency Format" value={customerData?.currencyFormat || "N/A"} />
                  <SmallDetailBox label="Date Format" value={customerData?.dateFormat || "N/A"} />
                  <SmallDetailBox label="Decimal Places" value={customerData?.decimalPlaces || "N/A"} />
                  <LargeDetailBox label="First Day Of The Week" value={customerData?.firstdayoftheweek || "N/A"} />
                </div>
              )}
            </div>
          </div>
          {!isAdvanced && (
            <div className='company-left-third left-customer'>
              {!isEdit ? (
                <>
                  <SmallDetailBox label="Country/ Region" value={customerData?.country?.name || "N/A"} />
                  <SmallDetailBox label="State" value={customerData?.state?.name || "N/A"} />
                  <SmallDetailBox label="Street 1" value={customerData?.street_1 || "N/A"} />
                  <SmallDetailBox label="Street 2" value={customerData?.street_2 || "N/A"} />
                  <SmallDetailBox label="City" value={customerData?.city || "N/A"} />
                  <SmallDetailBox label="Pincode" value={customerData?.pin_code || "N/A"} />
                </>
              ) : (
                <>
                  <SearchSelectBoxDrown
                    label="Country/ Region"
                    border='blue-border'
                    options={countries.map(country => ({
                      value: country.id.toString(),
                      label: country.name
                    }))}
                    defaultValue={customerData?.country?.id?.toString()}
                    field={{ showFlag: true }}
                    onChange={handleCountryChange}
                    className="w-50"
                  />

                  <SearchSelectBoxDrown
                    label="State"
                    border='blue-border'
                    options={states.map(state => ({
                      value: state.id,
                      label: state.name,
                    }))}
                    defaultValue={customerData?.state?.id}
                    onChange={(e) => setCustomerData({
                      ...customerData,
                      state: states.find(state => state.id === parseInt(e.target.value))
                    })}
                    className="w-50"
                    disabled={!customerData?.country?.id || states.length === 0}
                  />

                  <InputBoxSmall
                    label="Street 1"
                    border='blue-border'
                    defaultValue={customerData?.street_1}
                    onChange={(e) => setCustomerData({ ...customerData, street_1: e.target.value })}
                    className="w-50"
                  />
                  <InputBoxSmall
                    label="Street 2"
                    border='blue-border'
                    defaultValue={customerData?.street_2}
                    onChange={(e) => setCustomerData({ ...customerData, street_2: e.target.value })}
                    className="w-50"
                  />
                  <InputBoxSmall
                    label="City"
                    border='blue-border'
                    defaultValue={customerData?.city}
                    onChange={(e) => setCustomerData({ ...customerData, city: e.target.value })}
                    className="w-50"
                  />
                  <InputBoxSmall
                    label="Pincode"
                    border='blue-border'
                    defaultValue={customerData?.pin_code}
                    onChange={(e) => setCustomerData({ ...customerData, pin_code: e.target.value })}
                    className="w-50"
                  />
                </>
              )}
            </div>
          )}
          <button
            className="archive-customer fts-15 ftw-4"
            onClick={() => setIsArchivePopupOpen(true)}
          >
            <svg
              className="icon"
              xmlns="http://www.w3.org/2000/svg"
              width="18"
              height="18"
              viewBox="0 0 18 18"
              fill="none"
            >
              <path
                d="M9 15L13 11L11.6 9.6L10 11.2V7H8V11.2L6.4 9.6L5 11L9 15ZM0 18V2.8L2.3 0H15.7L18 2.8V18H0ZM2.4 3H15.6L14.75 2H3.25L2.4 3Z"
                fill="white"
              />
            </svg>
            {customerData?.is_archived ? 'Unarchive Customer' : 'Archive Customer'}
          </button>
        </div>

        {!(isAdvanced || isEdit) && (
          <div className='right-customer-details-whole'>
            <div className='customer-inner-table-container'>
              <input
                className='ml-3 table-selectbox'
                type="checkbox"
                name="selectAll"
                checked={isParentSelected}
                onChange={handleParentCheckboxChange}
              />
              <span className=' black common-text fts-15 ftw-5'>
                All Users ({userData.length})
              </span>
              <table className='customer-table'>
                <thead className='inner-customer-table-head'>
                  <tr className='inner-customer-table-tr'>
                    <th className='pl-3 name-inner-customer'>NAME</th>
                    <th>EMAIL</th>
                    <th>PHONE</th>
                    <th>ROLE</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className='inner-customer-tbody'>
                  {userData.map((user) => (
                    <tr key={user.id} className='inner-customer-tbody-tr common-text fts-14 black'>
                      <td>
                        <input className='ml-3 table-selectbox' type="checkbox" checked={selectedItems.includes(user.id)}
                          onChange={() => handleChildCheckboxChange(user.id)} />
                        {user?.full_name || "N/A"}
                      </td>
                      <td className='txt-lc'>{user?.email || "N/A"}</td>
                      <td>{user?.phone || "N/A"}</td>
                      <td>{user?.role?.name || 'N/A'}</td>
                      <td className={user.status === 'active' ? 'green' : 'red'}>
                        {statusMap[user?.status || "N/A"]}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
              {userPagination && userPagination.total_pages > 1 && (
                <Pagination
                  currentPage={userPagination.current_page}
                  totalPages={userPagination.total_pages}
                  totalCount={userPagination.total_items}
                  perPage={userPagination.items_per_page}
                  onPageChange={handleUserPageChange}
                />
              )}
            </div>

            <div className='customer-inner-table-container'>
              <span className='pl-3 black common-text fts-15 ftw-5 '>Subscription History</span>



              <table className='customer-table'>
                <thead className='inner-customer-table-head'>
                  <tr className='inner-customer-table-tr'>
                    <th className='pl-3 name-inner-customer w-15'>Plan</th>
                    <th>Start & End Date</th>
                    <th>User Limit</th>
                    <th>Status</th>
                  </tr>
                </thead>
                <tbody className='inner-customer-tbody'>
                  {subscriptionData.map((subscription) => (
                    <tr key={subscription.id} className='inner-customer-tbody-tr common-text fts-14 black'>
                      <td className='pl-3'>{subscription.plan || "N/A"}</td>
                      <td>
                        {formatDate(subscription?.start_date)} to {formatDate(subscription?.end_date)}
                      </td>
                      <td className='st-container-td'>
                        <span className='green'>0 / </span>
                        {subscription.user_limit}

                        <svg
                          className={subscription.status === 'Active' ? 'settings-icon' : 'hidden'}
                          width="11"
                          height="11"
                          viewBox="0 0 11 11"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                          onClick={() => {
                            setSelected(subscription.id);
                            setIsPopupOpen(true);
                            fetchHistory(subscription.id);
                          }}
                        >
                          <path d="M9.74239 5.5C9.74239 5.3735 9.73673 5.2525 9.72542 5.126L10.7775 4.3505C11.0038 4.1855 11.066 3.8775 10.9246 3.6355L9.86683 1.859C9.79901 1.7425 9.6893 1.65448 9.55879 1.61184C9.42829 1.5692 9.28618 1.57496 9.15977 1.628L7.94362 2.1285C7.73432 1.9855 7.51372 1.859 7.2818 1.7545L7.11776 0.484C7.08382 0.209 6.84059 0 6.55777 0H4.44789C4.15941 0 3.91618 0.209 3.88224 0.484L3.7182 1.7545C3.48628 1.859 3.26568 1.9855 3.05638 2.1285L1.84023 1.628C1.58003 1.518 1.27458 1.617 1.13317 1.859L0.0754002 3.641C-0.0660127 3.883 -0.00379103 4.1855 0.22247 4.356L1.27458 5.1315C1.25099 5.37847 1.25099 5.62703 1.27458 5.874L0.22247 6.6495C-0.00379103 6.8145 -0.0660127 7.1225 0.0754002 7.3645L1.13317 9.141C1.27458 9.383 1.58003 9.482 1.84023 9.372L3.05638 8.8715C3.26568 9.0145 3.48628 9.141 3.7182 9.2455L3.88224 10.516C3.91618 10.791 4.15941 11 4.44223 11H6.55211C6.83494 11 7.07817 10.791 7.11211 10.516L7.27615 9.2455C7.50806 9.141 7.72867 9.0145 7.93796 8.8715L9.15411 9.372C9.41431 9.482 9.71976 9.383 9.86117 9.141L10.9189 7.3645C11.0604 7.1225 10.9981 6.82 10.7719 6.6495L9.71976 5.874C9.73673 5.7475 9.74239 5.6265 9.74239 5.5ZM5.52263 7.425C4.43092 7.425 3.54285 6.5615 3.54285 5.5C3.54285 4.4385 4.43092 3.575 5.52263 3.575C6.61433 3.575 7.50241 4.4385 7.50241 5.5C7.50241 6.5615 6.61433 7.425 5.52263 7.425Z" fill="#094C80" />

                        </svg>
                        <span className={subscription.status === 'Active' ? 'hidden' : 'eye'}>
                          <svg
                            onClick={() => setIsViewPopupOpen(true)}
                            className='eye' width="19" height="11" viewBox="0 0 19 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9.5 0C4.18985 0 0 5.49964 0 5.49964C0 5.49964 4.18985 11 9.5 11C13.5604 11 19 5.49964 19 5.49964C19 5.49964 13.5604 0 9.5 0ZM9.5 8.92605C7.63519 8.92605 6.1173 7.38894 6.1173 5.49964C6.1173 3.61034 7.63519 2.07253 9.5 2.07253C11.3648 2.07253 12.8827 3.61034 12.8827 5.49964C12.8827 7.38894 11.3648 8.92605 9.5 8.92605ZM9.5 3.49913C9.2376 3.49411 8.97685 3.54213 8.73299 3.64039C8.48912 3.73866 8.26704 3.88519 8.07972 4.07142C7.8924 4.25765 7.7436 4.47984 7.64203 4.72501C7.54045 4.97017 7.48813 5.2334 7.48813 5.49929C7.48813 5.76518 7.54045 6.0284 7.64203 6.27357C7.7436 6.51873 7.8924 6.74093 8.07972 6.92716C8.26704 7.11339 8.48912 7.25992 8.73299 7.35818C8.97685 7.45644 9.2376 7.50447 9.5 7.49945C10.0171 7.48956 10.5098 7.27448 10.8721 6.90045C11.2344 6.52643 11.4373 6.02332 11.4373 5.49929C11.4373 4.97526 11.2344 4.47215 10.8721 4.09812C10.5098 3.7241 10.0171 3.50902 9.5 3.49913Z" fill="#094C80" />

                          </svg>
                        </span>

                      </td>
                      <td className={subscription?.status === 'Active' ? 'green' : 'red'}>
                        {subscription.status || "N/A"}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}
      </div>

      <UserEditPopup
        isOpen={isPopupOpen}
        title="ADD/REMOVE USER"
        // currentLimit={items.find(sub => sub.id === selected)?.user_limit}
        paymentMethod="upi"
        paymentOptions={paymentOptions}
        historyData={history}
        onSave={ChangeUser}
        onClose={closePopups}
      />
      <ArchivePopup
        isOpen={isArchivePopupOpen}
        isArchived={customerData?.is_archived}
        archivename={customerData?.name}
        onSave={handleArchiveClick}
        onClose={() => setIsArchivePopupOpen(false)}
      />
      <UserLimitViewPopup
        isOpen={isViewPopupOpen}
        title="View User Limit"
        currentLimit={currentLimit}
        historyData={history}
        onClose={() => setIsViewPopupOpen(false)}
      />
    </div>
  );
};

export default CustomerDetail;